import { render } from "./TroyersMeat.vue?vue&type=template&id=0782b246&scoped=true"
import script from "./TroyersMeat.vue?vue&type=script&lang=js"
export * from "./TroyersMeat.vue?vue&type=script&lang=js"

import "./TroyersMeat.vue?vue&type=style&index=0&id=0782b246&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0782b246"]])

export default __exports__